
/* styles */
require("!!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-rewriter?id=data-v-32ef3187!sass-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Wrap.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./Wrap.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-32ef3187!../node_modules/vue-loader/lib/selector?type=template&index=0!./Wrap.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/Wrap.vue
// module id = 587
// module chunks = 0